import { errorParser, messageParser } from './NotificationParser';
import notificationKeeperFactory from './NotificationKeeper';
import { SSE_ERROR, SPLIT_UPDATE, SEGMENT_UPDATE, MY_SEGMENTS_UPDATE, SPLIT_KILL, OCCUPANCY, CONTROL } from '../constants';
import logFactory from '../../utils/logger';
var log = logFactory('splitio-sync:sse-handler');
/**
 * Factory for SSEHandler
 *
 * @param {Object} pushEmitter emitter for emitting events related to feedback-loop & update queues
 */

export default function SSEHandlerFactory(pushEmitter) {
  var notificationKeeper = notificationKeeperFactory(pushEmitter);
  return {
    handleOpen: function handleOpen() {
      notificationKeeper.handleOpen();
    },
    /* HTTP & Network errors */
    handleError: function handleError(error) {
      var errorWithParsedData = error;
      try {
        errorWithParsedData = errorParser(error);
      } catch (err) {
        log.warn("Error parsing SSE error notification: ".concat(err));
      }
      pushEmitter.emit(SSE_ERROR, errorWithParsedData);
    },
    /* NotificationProcessor */
    handleMessage: function handleMessage(message) {
      var messageWithParsedData;
      try {
        messageWithParsedData = messageParser(message);
      } catch (err) {
        log.warn("Error parsing new SSE message notification: ".concat(err));
        return;
      }
      var _messageWithParsedDat = messageWithParsedData,
        parsedData = _messageWithParsedDat.parsedData,
        data = _messageWithParsedDat.data,
        channel = _messageWithParsedDat.channel,
        timestamp = _messageWithParsedDat.timestamp;
      log.debug("New SSE message received, with data: ".concat(data, ".")); // we only handle update events if streaming is up.

      if (!notificationKeeper.isStreamingUp() && parsedData.type !== OCCUPANCY && parsedData.type !== CONTROL) return;
      switch (parsedData.type) {
        /* update events */
        case SPLIT_UPDATE:
          pushEmitter.emit(SPLIT_UPDATE, parsedData.changeNumber);
          break;
        case SEGMENT_UPDATE:
          pushEmitter.emit(SEGMENT_UPDATE, parsedData.changeNumber, parsedData.segmentName);
          break;
        case MY_SEGMENTS_UPDATE:
          pushEmitter.emit(MY_SEGMENTS_UPDATE, parsedData, channel);
          break;
        case SPLIT_KILL:
          pushEmitter.emit(SPLIT_KILL, parsedData.changeNumber, parsedData.splitName, parsedData.defaultTreatment);
          break;

        /* occupancy & control events, handled by NotificationManagerKeeper */

        case OCCUPANCY:
          notificationKeeper.handleOccupancyEvent(parsedData.metrics.publishers, channel, timestamp);
          break;
        case CONTROL:
          notificationKeeper.handleControlEvent(parsedData.controlType, channel, timestamp);
          break;
        default:
          break;
      }
    }
  };
}